<template>
  <div>
    <v-snackbar :value="showCookieBar" bottom color="#383940" :timeout="-1">
      <v-row align="center" justify="center">
        <v-col class="shrink">
          <v-icon>mdi-cookie</v-icon>
        </v-col>
        <v-col class="grow">
          På denne siden brukes informasjonskapsler for å få statistikk på
          bruken av siden vår. Ved å fortsette å bruke siden bekrefter du at du
          godtar dette
          <a class="yellow--text" href="https://www.trysilhus.no/personvern/">
            Les mer
          </a>
        </v-col>
      </v-row>
      <template v-slot:action="{ attrs }">
        <v-btn
          depressed
          light
          color="yellow"
          v-bind="attrs"
          @click="saveCookie"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <BaseDialog
      v-model="cookiesOff"
      title="Informasjonskapsler (Cookies)"
      persistent
      btnActionName="Last side"
      @action="refresh"
    >
      Bygg Trysilhus er avhengig av at informasjonskapsler er skrudd på. For å
      kunne logge inn på Bygg Trysilhus må du skru på informasjonskapsler.
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  data() {
    return {
      cookiesOff: false,
      showCookieBar: false,
    };
  },
  mounted() {
    try {
      localStorage;
    } catch (e) {
      this.cookiesOff = true;
    } finally {
      const btCookieAccepted = localStorage.getItem("btCookieAccepted");

      if (!btCookieAccepted) {
        this.showCookieBar = true;
      }
    }
  },
  methods: {
    saveCookie() {
      localStorage.setItem("btCookieAccepted", "true");
      this.showCookieBar = false;
    },
    refresh() {
      this.$router.go(0);
    },
  },

  components: {
    BaseDialog,
  },
});
</script>

<style lang="scss">
.cookie {
  .v-snack {
    padding-bottom: calc(0px + env(safe-area-inset-bottom)) !important;
  }
}
</style>
